'use strict';

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Allows embedding reservation terms in HTML code. HTML Contents of this 
// directive are shown when reservation terms are being requested by calling
// reservation terms opener in winresReservationContextService.
_module3.default.directive('winresReservationTerms', ['$uibModal', 'winresReservationContextService', function ($uibModal, winresReservationContextService) {
    return {
        restrict: 'E', //Element-only usage
        transclude: true, //Accept HTML contents of the element
        link: function link($scope, $element, $attrs, controller, $transclude) {
            var transcludedElement;
            $transclude($scope, function (clone) {
                transcludedElement = clone;
            });
            winresReservationContextService.setReservationTermsOpener(function () {
                $uibModal.open({
                    template: require('./modal.html'),
                    controller: 'winresReservationPopupController',
                    controllerAs: '$ctrl',
                    windowClass: 'winres-reservation-terms winres-reservation-component',
                    size: 'lg',
                    resolve: {
                        content: function content() {
                            return transcludedElement;
                        }
                    }

                });
            });
        },
        template: ''
    };
}]);


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationTerms/winresReservationTerms.js
// module id = 373
// module chunks = 2